import React, { useState, useEffect,useRef  } from 'react';
import styles from './scrollMan.module.css';
import bearman from "../../assets/images/bearman.png"

const ScrollMan = ()=> {
  const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 35 });
  const requestRef = useRef();

  useEffect(() => {
    const handleScroll = ()=> {
      requestRef.current = requestAnimationFrame(() => {
        setScrollPosition({ x: window.scrollX, y: window.scrollY });
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      cancelAnimationFrame(requestRef.current);
    };
  }, []);

  const imageStyle = {
    transform: `translateY(-${scrollPosition.y}px)`,
    transition: 'transform 0.9s ease-out', // add a transition for smoother animation    
  };

  const textStyle = {
    transform: `translateX(${scrollPosition.y}px)`,
    transition: 'transform 0.3s ease-out', // add a transition for smoother animation
  };

  return (
    <div className={styles.scrollmanContainer}>
      <div className={styles.imageContainer} style={imageStyle}>
        <img src={bearman} alt="image" />
      </div>
      <div className={styles.textContrainer}>
        <p className={styles.scrollText} style={textStyle}>اولین ترامپولین پارک ایران</p>
      </div>
    </div>
  );
}

export default ScrollMan;
